import {
  BackgroundTypeBackgroundColorSave,
  BackgroundTypeGradientSave,
  BackgroundTypeImageSave,
  BackgroundTypeImageAndColorSave,
  ImageGradientSave,
  ImageAsBackgroundSave,
  BackgroundVideoSave,
} from './_partials';

const BackgroundTypesSave = ({
  blockId,
  defaultBlockCssClass,
  backgroundType,
  backgroundGradientOptions,
  backgroundColorOptions,
  backgroundImageOptions,
  backgroundImageAndColorOptions,
  imageGradientBackgroundOptions,
  imageAsBackgroundOptions,
  backgroundVideoOptions,
  printBackgroundStyles = false,
}) => {
  return (
    <>
      {backgroundType === 'background_color' && (
        <BackgroundTypeBackgroundColorSave
          {...{
            blockId,
            defaultBlockCssClass,
            backgroundColorOptions,
            printBackgroundStyles,
          }}
        />
      )}

      {backgroundType === 'background_gradient' && (
        <BackgroundTypeGradientSave
          {...{
            blockId,
            defaultBlockCssClass,
            backgroundGradientOptions,
            printBackgroundStyles,
          }}
        />
      )}

      {backgroundType === 'background_image' && (
        <BackgroundTypeImageSave
          {...{
            blockId,
            defaultBlockCssClass,
            backgroundImageOptions,
            printBackgroundStyles,
          }}
        />
      )}

      {backgroundType === 'background_image_color' && (
        <BackgroundTypeImageAndColorSave
          {...{
            blockId,
            defaultBlockCssClass,
            backgroundImageAndColorOptions,
            printBackgroundStyles,
          }}
        />
      )}
      {backgroundType === 'picture_tag' && (
        <ImageAsBackgroundSave
          {...{ blockId, defaultBlockCssClass, imageAsBackgroundOptions }}
        />
      )}

      {backgroundType === 'image_gradient' && (
        <ImageGradientSave
          {...{
            blockId,
            defaultBlockCssClass,
            imageGradientBackgroundOptions,
            printBackgroundStyles,
          }}
        />
      )}

      {backgroundType === 'background_video' && (
        <BackgroundVideoSave
          {...{ blockId, defaultBlockCssClass, backgroundVideoOptions }}
        />
      )}
    </>
  );
};

export default BackgroundTypesSave;
